import { makeStyles } from '@material-ui/core'

/**
 * No `const COLUMNS` here, unlike NotificationDeliveriesTable.styles.ts.
 *
 * This table is generic over six resource types with different column sets, so
 * the grid template is derived from the `columns` array the caller supplies and
 * applied inline. §2's rule is that ONE source feeds header, row and skeleton so
 * they cannot drift — the array is that source. Hard-coding a template here
 * would give five of the six the wrong one.
 */
const cell = {
  // Grid children default to min-width:auto, so one long unbreakable token — a
  // dotted category key, an encoded id — sets the column floor and shoves every
  // other column aside. min-width:0 lets the track shrink to its fr share;
  // overflow-wrap breaks the token inside its own cell.
  minWidth: 0,
  overflowWrap: 'anywhere' as const,
  // A cell holding a Chip beside text: Chip is inline-flex and Typography
  // renders a block <p>, so without flex the text drops to a second line and
  // that row alone becomes two lines tall.
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap' as const,
  gap: 4
}

const useStyles = makeStyles((theme) => ({
  tableHead: {
    '& > div': cell,
    width: '100%',
    display: 'grid',
    color: theme.palette.text.secondary,
    alignItems: 'center',
    padding: '0 0 0 12px',
    marginBottom: 4,
    marginTop: 4
  },
  tableRow: {
    '& > div': cell,
    display: 'grid',
    minHeight: 64,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    borderRadius: 20,
    padding: '0 0 0 12px',
    marginBottom: 4
  },
  actionsCell: {
    justifyContent: 'flex-end'
  },
  // The mobile layout is a stacked card, not a narrower grid. A seven-column
  // grid on a phone gives every column a few characters and wraps all of them;
  // one label-and-value pair per line stays readable at any width.
  mobileCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    backgroundColor: theme.palette.background.default,
    borderRadius: 20,
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
    '& > div': {
      minWidth: 0,
      overflowWrap: 'anywhere',
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: 4
    }
  },
  // Carries the column header down into the card. Without it a mobile row is a
  // column of bare values with nothing saying what they are.
  mobileLabel: {
    minWidth: theme.spacing(12)
  },
  mobileToolbar: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  refreshButtonContainer: {
    justifyContent: 'flex-end'
  },
  detail: {
    margin: 0,
    padding: theme.spacing(1.5),
    overflowWrap: 'anywhere',
    whiteSpace: 'pre-wrap',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12
  },
  noDataImageContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(4)
  }
}))

export default useStyles
